<template>
    <div class="xhsublist">
        <div class="header">
            <img :src="detail.imgurl" alt="">
        </div>
        <div class="body">
            <div class="tabs">
                <div :class="[active==index?'active':'','tab']" @click="active = index" v-for="(item,index) in tablist" :key="item.id">{{item.name}}</div>
            </div>
            <div class="centent">
                <div class="html">
                    <div class="draw">
                        <div class="btn" @click="showRule = true">活动规则</div>
                        <div class="btn" @click="gorank">活动排行</div>
                    </div>
                    <div class="sublist">
                        <div class="citem" @click="godetail(item)" v-for="item in sublist">
                            <div class="tt">
                                <div>{{item.title}}</div>
                                <div><van-icon name="clock-o" />{{item.start_time}} ~ {{item.end_time}}</div>
                            </div>
                            <div class="img"></div>
                        </div>
                    </div>
                        
                    <!-- <div v-html="active==1?detail.disclaimer:detail.intro"></div> -->
                </div>
            </div>
        </div>
        <van-dialog
        v-model="showRule"
        class="sports_item_rule_dialog rule"
        :show-confirm-button="false"
        message-align="left"
        close-on-click-overlay
        >
        <van-icon
            name="close"
            style="position:fixed;right:10px;"
            size=".4rem"
            @click="showRule=false"
        />
        <div
            class="rule"
        >
            <div
            class="header"
            slot="title"
            >活动规则</div>
            <div v-html="detail.rule"></div>
        </div>
        </van-dialog>
    </div>
</template>

<script>
import moment from "moment";
import "./index.less";
export default {
    props: ["activity_id","acid"],
    data() {
        return {
            detail: {},
            tablist: [
                {
                    id: 1,
                    name: '成人组',
                    sports_item_sub_ids: '9354,9355,9356'
                },{
                    id: 2,
                    name: '儿童组',
                    sports_item_sub_ids: '9357,9358,9359'
                }
            ],
            sublist: [],
            active: 0,
            showRule: false
        };
    },
    watch: {
        active(newvalue, oldvalue) {
            this.init()             
        },
    },
    methods: {
        gorank() {
            this.$router.push({name:'xhrank'})
        },
        godetail(item) {
            this.$router.push({name: 'sportsDetail', params:{item_sub_id:item.id,sports_id:item.sports_id,item_id:item.sports_item_id}})
        },
        init: function () {
            this.$toast.loading({
                duration: 0,
            });
            let params = { itemid: 392,sports_item_sub_ids: this.tablist[this.active].sports_item_sub_ids };
            this.$api.sports.compareSub(params).then(res => {
                if(res.status==200){
                    this.detail = res.data.detail
                    this.sublist = res.data.list
                    this.$toast.clear();
                }
            });
        },
    },
    mounted() {
        this.init();
    },
}
</script>